module.exports = __webpack_public_path__ + "img/image-block-3.081c31e8.png";